import React from 'react';
import { Create, SimpleForm, useGetList } from 'react-admin';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import CustomTextField from '../../../ui/custom-text-field';
import CustomAutocomplete from '../../../ui/custom-autocomplete';
import { ContentPageSX } from '../../../styled/custom';
import { leastOneOption, minLength } from '../../../utils/schemas';
import { ColorInput } from 'react-admin-color-picker';


const Schema = Yup.object(
{
  name: minLength(3, "Digite o nome"),
  cities: leastOneOption("Selecione pelo menos uma cidade")
});

const RegionCreate = () =>
{
  const { data, isLoading } = useGetList("setup/cities");
  return (
    <Create
      title="Nova Região"
      redirect="list"
      sx={ContentPageSX}>
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}>
        <CustomTextField name="name" label="Nome" fullWidth isRequired/>
        <ColorInput source="color" name="color" label="Cor da região" variant="outlined" />
        {!isLoading && <CustomAutocomplete data={data} name="cities" label="Cidade(s)" fullWidth isrequired="true"/>}
      </SimpleForm>
    </Create>
  )
}

export default RegionCreate;
